import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React from "react";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { Grid, Dialog, Button, SubmitButton, Debug, SearchSelect } from "../../../../../../";
import { makeStyles } from "@material-ui/styles";
import { TextField } from "formik-material-ui";
import { Typography, Divider } from "@material-ui/core";
import moment from "moment";
var useStyles = makeStyles(function (theme) {
  return {
    containerButtonsAttendance: {
      marginTop: "16px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-around"
    },
    containerActions: {
      marginTop: "32px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    }
  };
});
var checkoutSchema = Yup.object().shape({
  key: Yup.string().required(),
  status: Yup.string().required(),
  responsible: Yup.string().nullable().when("status", {
    is: "attended",
    then: Yup.string().required()
  })
});

var MobileDialogCampusCalendarCheckoutAddCheckout = function MobileDialogCampusCalendarCheckoutAddCheckout(props) {
  // console.log("MobileDialogCampusCalendarCheckoutAddCheckout props", props);
  var classes = useStyles();
  var initialValues = props.data ? props.data.checkout ? _objectSpread(_objectSpread({}, props.data), {}, {
    responsible: props.data.checkout.responsible ? props.data.checkout.responsible.id || null : null
  }) || {
    key: null,
    status: null,
    responsible: null
  } : props.data : {
    key: null,
    status: null,
    responsible: null
  };
  return /*#__PURE__*/React.createElement(Dialog, {
    fullWidth: true,
    open: props.open,
    onClose: props.onClose
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: initialValues,
    validationSchema: checkoutSchema,
    onSubmit: function onSubmit(values) {
      props.onSubmit({
        key: values.key,
        checkout: {
          date: moment().format("YYYY-MM-DDTHH:mm:ssZ"),
          responsible: values.responsible ? {
            id: values.responsible,
            name: props.data.responsibles.find(function (responsible) {
              return responsible.value === values.responsible;
            }).label
          } : {
            id: null,
            name: null
          },
          type: "exit",
          done: true
        },
        status: values.status
      });
      props.onClose();
    },
    render: function render(_ref) {
      var values = _ref.values,
          isValid = _ref.isValid,
          isSubmitting = _ref.isSubmitting,
          setFieldValue = _ref.setFieldValue;
      return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        spacing: 2
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body1",
        align: "center"
      }, props.translation ? props.translation.title || "Check Out" : "Check Out"), /*#__PURE__*/React.createElement(Typography, {
        variant: "body2",
        align: "center"
      }, props.data ? props.data.name || "" : "")), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body1"
      }, props.translation ? props.translation.labels ? props.translation.labels.attendance || "Has he/she been picked up?" : "Has he/she been picked up?" : "Has he/she been picked up?"), /*#__PURE__*/React.createElement("div", {
        className: classes.containerButtonsAttendance
      }, /*#__PURE__*/React.createElement(Button, {
        variant: values.status === "attended" ? "contained" : "outlined",
        color: "primary",
        onClick: function onClick() {
          return setFieldValue("status", "attended");
        }
      }, props.translation ? props.translation.buttons ? props.translation.buttons.yes || "Yes" : "Yes" : "Yes"), /*#__PURE__*/React.createElement(Button, {
        variant: values.status === "not_attended" ? "contained" : "outlined",
        color: "secondary",
        onClick: function onClick() {
          setFieldValue("status", "not_attended");
          setFieldValue("responsible", null);
        }
      }, props.translation ? props.translation.buttons ? props.translation.buttons.no || "No" : "No" : "No"))), values.status === "attended" && /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Field, {
        name: "responsible",
        label: props.translation ? props.translation.inputs ? props.translation.inputs.responsible || "Who is picking he/she up?" : "Who is picking he/she up?" : "Who is picking he/she up?",
        component: SearchSelect,
        isSearchable: false,
        mobile: true,
        options: props.data ? props.data.responsibles ? props.data.responsibles.map(function (responsible) {
          return {
            label: responsible.label,
            value: responsible.value
          };
        }) : [] : [],
        variant: "outlined"
      })), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.containerActions
      }, /*#__PURE__*/React.createElement(Button, {
        type: "button",
        size: "medium",
        className: classes.mr30,
        color: "secondary",
        variant: "outlined",
        onClick: props.onClose
      }, props.translation ? props.translation.buttons ? props.translation.buttons.cancel || "Cancel" : "Cancel" : "Cancel"), /*#__PURE__*/React.createElement(Button, {
        size: "medium",
        color: "primary",
        variant: "outlined",
        disabled: !isValid || isSubmitting,
        component: SubmitButton,
        type: "submit"
      }, props.translation ? props.translation.buttons ? props.translation.buttons.submit || "Save" : "Save" : "Save"))));
    }
  }));
};

export { MobileDialogCampusCalendarCheckoutAddCheckout };